var n={};function r(r){n=r}function t(){return n}export{t as getConfig,r as setConfig};
//# sourceMappingURL=getConfig.js.map
